const rdcn = (translations) => translations?.rechargeDebitCreditNote || {}

export const getColumnDefs = (translations) => {
    const d = rdcn(translations)
    return [
    { headerName: d.sn || 'S/N', field: 'SN', headerSx: { textAlign: 'right',width:'2.97%' },xlCol: { dataType: 'number', dataFormatter: null },showfilter:false, },
    { headerName: d.lrNumber || 'LR\nNumber', field: 'LRNO', headerSx: { textAlign: 'left',width:'10.41%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: d.lrDate || 'LR\nDate', field: 'LRDate', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: d.partyName || 'Party\nName', field: 'PartyName', headerSx: { textAlign: 'left',width:'10.41%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: d.partyGstin || 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',width:'10.41%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: d.paymentTypeNl || 'Payment\nType', field: 'PaymentType', headerSx: { textAlign: 'left',width:'8.11%'},  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: d.voucherTxnType || 'Voucher Txn.\nType', field: 'TransactionType', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: d.gstInvoiceNumber || 'GST Invoice\nNumber', field: 'GSTInv', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: d.gstInvoiceDate || 'GST Invoice\nDate', field: 'GSTDate', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: d.gstInvoiceAmount || 'GST Invoice\nAmount', field: 'GSTAmt', headerSx: { textAlign: 'right',width:'8.11%' },  xlCol: { dataType: 'number', dataFormatter: null },showfilter:true },
    { headerName: d.totalOutstanding || 'Total\nOutstanding', field: 'Outstanding', headerSx: { textAlign: 'right',width:'8.11%' },  xlCol: { dataType: 'number', dataFormatter: null },showfilter:true },
    { headerName: d.voucherAmount || 'Voucher\nAmount', field: 'NetAmount', headerSx: { textAlign: 'right',width:'8.11%' },  xlCol: { dataType: 'number', dataFormatter: null },showfilter:true },
]
}

export const getColumnDefsForGrouping = (translations) => {
    const d = rdcn(translations)
    return {
  SN: d.sn || 'S/N',
  LRNO: d.lrNumber || 'LR\nNumber',
  LRDate: d.lrDate || 'LR\nDate',
  PartyName: d.partyName || 'Party\nName',
  GSTN: d.partyGstin || 'Party\nGSTIN',
  PaymentType: d.paymentTypeNl || 'Payment\nType',
  TransactionType: d.voucherTxnType || 'Voucher Txn.\nType',
  GSTInv: d.gstInvoiceNumber || 'GST Invoice\nNumber',
  GSTDate: d.gstInvoiceDate || 'GST Invoice\nDate',
  GSTAmt: d.gstInvoiceAmount || 'GST Invoice\nAmount',
  Outstanding: d.totalOutstanding || 'Total\nOutstanding',
  NetAmount: d.voucherAmount || 'Voucher\nAmount'
}
}

export const getColumnDefsOneFilter = (translations) => {
    const d = rdcn(translations)
    return [
    { headerName: d.transactionType || 'Transaction Type', field: 'voucherType', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.partyCity || 'Party City', field: 'partyCity', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.partyName || 'Party Name', field: 'partyName', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.partyGstin || 'Party GSTIN', field: 'PartyGSTIN', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
]
}

export const tab1Data = [
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
]

export const getColumnDefsTwo = (translations) => {
    const d = rdcn(translations)
    return [
    { header: d.sn || 'S/N',headerName: d.sn || 'S/N', field: 'srNo', headerSx: { textAlign: 'right',minWidth:'50px' }, showfilter:false ,allowSorting: true,isSelected: true,isDefault: true,isMandatory: true,id: 0, },
    { header: d.voucherNumber || 'Voucher\nNumber',headerName: d.voucherNumber || 'Voucher\nNumber', field: 'VoucherNo', headerSx: { textAlign: 'left',minWidth:'50px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 1,},
    { header: d.voucherDate || 'Voucher\nDate',headerName: d.voucherDate || 'Voucher\nDate', field: 'VoucherDate', headerSx: { textAlign: 'left',minWidth:'120px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 2,},
    { header: d.bookingDate || 'Booking\nDate',headerName: d.bookingDate || 'Booking\nDate', field: 'BookingDate', headerSx: { textAlign: 'left',minWidth:'120px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 3,},
    { header: d.lrNumber || 'LR\nNumber',headerName: d.lrNumber || 'LR\nNumber', field: 'LRNO', headerSx: { textAlign: 'left',minWidth:'126px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 4,},
    { header: d.partyName || 'Party\nName',headerName: d.partyName || 'Party\nName', field: 'Party', headerSx: { textAlign: 'left',minWidth:'140px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 5,},
    { header: d.partyGstin || 'Party\nGSTIN',headerName: d.partyGstin || 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',minWidth:'125px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 6,},
    { header: d.paymentTypeNl || 'Payment\nType',headerName: d.paymentTypeNl || 'Payment\nType', field: 'PaymentType', headerSx: { textAlign: 'left',minWidth:'60px'}, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 7,},
    { header: d.voucherTxnType || 'Voucher Txn.\nType',headerName: d.voucherTxnType || 'Voucher Txn.\nType', field: 'TransactionType', headerSx: { textAlign: 'left',minWidth:'60px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 8,},
    { header: d.gstInvoiceNumber || 'GST Invoice\nNumber',headerName: d.gstInvoiceNumber || 'GST Invoice\nNumber', field: 'GSTInv', headerSx: { textAlign: 'left',minWidth:'70px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 9,},
    { header: d.gstInvoiceDate || 'GST Invoice\nDate',headerName: d.gstInvoiceDate || 'GST Invoice\nDate', field: 'GSTDate', headerSx: { textAlign: 'left',minWidth:'120px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 10,},
    { header: d.gstInvAmount || 'GST Inv.\nAmount',headerName: d.gstInvAmount || 'GST Inv.\nAmount', field: 'GSTAmt', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 11,},
    { header: d.voucherAmount || 'Voucher\nAmount',headerName: d.voucherAmount || 'Voucher\nAmount', field: 'NetAmt', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 12,},
    { header: d.amountPaid || 'Amount\nPaid',headerName: d.amountPaid || 'Amount\nPaid', field: 'TotalPaidAmt', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 13,},
    { header: d.amountPending || 'Amount\nPending',headerName: d.amountPending || 'Amount\nPending', field: 'NetAmtPending', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 14,},
    { header: d.discountAmount || 'Discount\nAmount',headerName: d.discountAmount || 'Discount\nAmount', field: 'Discount', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 15,},
    { header: d.editDisc || 'Edit\nDisc.',headerName: d.editDisc || 'Edit\nDisc.', field: 'editDisc', headerSx: { textAlign: 'left',minWidth:'70px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 16,},
    { header: d.netAmtPending || 'Net Amt.\nPending',headerName: d.netAmtPending || 'Net Amt.\nPending', field: 'NetAmtToRcv', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 17,},
]
}

export const getColumnDefsTwoV2 = (translations) => {
    const d = rdcn(translations)
    return [
  { header: d.sn || 'S/N', headerName: d.sn || 'S/N', dataKey: 'srNo', headerSx: { textAlign: 'right', minWidth: '50px' }, showfilter: false, allowSorting: true, isSelected: true, isDefault: true, isMandatory: true, id: 1 ,
  xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
    halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 50, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.voucherNumber || 'Voucher\nNumber', headerName: d.voucherNumber || 'Voucher\nNumber', dataKey: 'VoucherNo', headerSx: { textAlign: 'left', minWidth: '50px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 2,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
 },
  { header: d.voucherDate || 'Voucher\nDate', headerName: d.voucherDate || 'Voucher\nDate', dataKey: 'VoucherDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 3 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.bookingDate || 'Booking\nDate', headerName: d.bookingDate || 'Booking\nDate', dataKey: 'BookingDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 4 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.lrNumber || 'LR\nNumber', headerName: d.lrNumber || 'LR\nNumber', dataKey: 'LRNO', headerSx: { textAlign: 'left', minWidth: '126px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 5 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.partyName || 'Party\nName', headerName: d.partyName || 'Party\nName', dataKey: 'Party', headerSx: { textAlign: 'left', minWidth: '140px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 6 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.partyGstin || 'Party\nGSTIN', headerName: d.partyGstin || 'Party\nGSTIN', dataKey: 'GSTN', headerSx: { textAlign: 'left', minWidth: '125px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 7 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.paymentTypeNl || 'Payment\nType', headerName: d.paymentTypeNl || 'Payment\nType', dataKey: 'PaymentType', headerSx: { textAlign: 'left', minWidth: '60px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 8,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.voucherTxnType || 'Voucher Txn.\nType', headerName: d.voucherTxnType || 'Voucher Txn.\nType', dataKey: 'TransactionType', headerSx: { textAlign: 'left', minWidth: '60px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 9,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.gstInvoiceNumber || 'GST Invoice\nNumber', headerName: d.gstInvoiceNumber || 'GST Invoice\nNumber', dataKey: 'GSTInv', headerSx: { textAlign: 'left', minWidth: '70px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 10,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.gstInvoiceDate || 'GST Invoice\nDate', headerName: d.gstInvoiceDate || 'GST Invoice\nDate', dataKey: 'GSTDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 11 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: d.gstInvAmount || 'GST Inv.\nAmount', headerName: d.gstInvAmount || 'GST Inv.\nAmount', dataKey: 'GSTAmt', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 12,
  xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
    halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
 },
  { header: d.voucherAmount || 'Voucher\nAmount', headerName: d.voucherAmount || 'Voucher\nAmount', dataKey: 'NetAmt', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 13,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: d.amountPaid || 'Amount\nPaid', headerName: d.amountPaid || 'Amount\nPaid', dataKey: 'TotalPaidAmt', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 14,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: d.amountPending || 'Amount\nPending', headerName: d.amountPending || 'Amount\nPending', dataKey: 'NetAmtPending', headerSx: { textAlign: 'lerightft', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 15,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: d.discountAmount || 'Discount\nAmount', headerName: d.discountAmount || 'Discount\nAmount', dataKey: 'discountValue', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 16,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: d.editDisc || 'Edit\nDisc.', headerName: d.editDisc || 'Edit\nDisc.', dataKey: 'editDisc', headerSx: { textAlign: 'left', minWidth: '70px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 17,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: d.netAmtPending || 'Net Amt.\nPending', headerName: d.netAmtPending || 'Net Amt.\nPending', dataKey: 'NetAmtToRcv', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 18,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
]
}

export const getHeaderTblDefs = (translations) => {
    const d = rdcn(translations)
    return [
        { header: d.fromVoucherDate || 'From Voucher Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null } },
        { header: d.toVoucherDate || 'To Voucher Date', dataKey: 'toDate', xlCol: { dataType: 'string', dataFormatter: null } },
        { header: d.partyCity || 'Party City', dataKey: 'partyCity', xlCol: { dataType: 'string', dataFormatter: null } },
        { header: d.partyName || 'Party Name', dataKey: 'partyName', xlCol: { dataType: 'string', dataFormatter: null } },
      ]
}

export const getColumnDefstwoFilter = (translations) => {
    const d = rdcn(translations)
    return [
    { headerName: d.fromVoucherDate || 'From Voucher Date', field: 'fromDate', headerSx: { textAlign: 'right',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:false, colSpan:4},
    { headerName: d.toVoucherDate || 'To Voucher Date', field: 'toDate', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true, colSpan:4},
    { headerName: d.partyCity || 'Party City', field: 'partyCity', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true, colSpan:4},
    { headerName: d.partyName || 'Party Name', field: 'partyName', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true, colSpan:5},
]
}

export const tab2Data = [
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {isTotalRow:true,
        totalCaption:'Total',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100', discount:'600', netAmtPending:'5400'
    },
]

export const getColumnDefsFilter = (translations) => {
    const d = rdcn(translations)
    return [
    { headerName: d.partyCity || 'Party City', field: 'partyCity',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.partyName || 'Party Name', field: 'partyName',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.voucherType || 'Voucher Type', field: 'voucherType',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.reportType || 'Report type', field: 'reportType',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
]
}

export const getColumnDefsFilterForSummary = (translations) => {
    const d = rdcn(translations)
    return [
    { headerName: d.partyCity || 'Party City', field: 'partyCity',colSpan:2, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.partyName || 'Party Name', field: 'partyName',colSpan:3, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.voucherType || 'Voucher Type', field: 'voucherType',colSpan:3, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.reportType || 'Report type', field: 'reportType',colSpan:2, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
]
}

export const getColumnDefsThree = (translations) => {
    const d = rdcn(translations)
    return [
    { headerName: d.sn || 'S/N', field: 'SN', headerSx: { textAlign: 'left',minWidth:'3%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:false},
    { headerName: d.voucherNo || 'Voucher\nNo.', field: 'VoucherNo', headerSx: { textAlign: 'left',minWidth:'10%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: d.voucherDate || 'Voucher\nDate', field: 'VoucherDate', headerSx: { textAlign: 'left',minWidth:'14.36%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: d.voucherType || 'Voucher\nType', field: 'TransactionType', headerSx: { textAlign: 'left',minWidth:'12.36%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: d.partyName || 'Party\nName', field: 'Party', headerSx: { textAlign: 'left',minWidth:'11.24%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: d.partyGstin || 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',minWidth:'11.24%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: d.voucherAmount || 'Voucher\nAmount', field: 'TotalNetAmt', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
    { headerName: d.amountReceived || 'Amount\nReceived', field: 'TotalPaidAmt', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
    { headerName: d.discount || 'Discount', field: 'Discount', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
    { headerName: d.amountOutstanding || 'Amount\nOutstanding', field: 'NetAmtToRcv', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
]
}

export const tab3SummaryData = [
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {isTotalRow:true,totalCaption:'Total',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
]

export const getColumnDefsFour = (translations) => {
    const d = rdcn(translations)
    return [
    { headerName: d.sn || 'S/N', field: 'SN', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:false},
    { headerName: d.voucherNumber || 'Voucher\nNumber', field: 'VoucherNo', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: d.voucherDate || 'Voucher\nDate', field: 'VoucherDate', headerSx: { textAlign: 'left',minWidth:'120px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.bookingDate || 'Booking\nDate', field: 'BookingDate', headerSx: { textAlign: 'left',minWidth:'120px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.lrNumber || 'LR\nNumber', field: 'LRNO', headerSx: { textAlign: 'left',minWidth:'126px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.partyName || 'Party\nName', field: 'Party', headerSx: { textAlign: 'left',minWidth:'140px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.partyGstin || 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',minWidth:'125px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.paymentTypeNl || 'Payment\nType', field: 'PaymentType', headerSx: { textAlign: 'left',minWidth:'82px'}, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.voucherTxnType || 'Voucher Txn.\nType', field: 'TransactionType', headerSx: { textAlign: 'left',minWidth:'60px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.gstInvoiceNumber || 'GST Invoice\nNumber', field: 'GSTInv', headerSx: { textAlign: 'left',minWidth:'70px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.gstInvoiceDate || 'GST Invoice\nDate', field: 'GSTDate', headerSx: { textAlign: 'left',minWidth:'120px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: d.gstInvAmount || 'GST Inv.\nAmount', field: 'GSTAmt', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: d.voucherAmount || 'Voucher\nAmount', field: 'TotalNetAmt', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: d.amountPaid || 'Amount\nPaid', field: 'TotalPaidAmt', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: d.discount || 'Discount', field: 'Discount', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: d.amountPending || 'Amount\nPending', field: 'NetAmtToRcv', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
]
}

export const tab3DetailedData = [
    {isSubHeadingRow:true, partyName:'Party Name: Shivaholic Private Ltd.', partyCity:'Party City: Ahmedabad',voucherTxnType:'Voucher Type: Booking'},
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0'
    },
    {isSubTotalRow:true,totalCaption:'Total: Shivaholic Private Ltd. (Ahmedabad)',  totalCaptionAlignment: 'right',  
        colSpan: 9,voucherTxnType:'Voucher Type: Booking',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100'},
    {isSubHeadingRow:true, partyName:'Party Name: Shivaholic Private Ltd.', partyCity:'Party City: Ahmedabad',voucherTxnType:'Voucher Type: Booking'},
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0'
    },
    {isSubTotalRow:true,totalCaption:'Total: Shivaholic Private Ltd. (Ahmedabad)', totalCaptionAlignment: 'right',  
        colSpan: 9, voucherTxnType:'Voucher Type: Delivery',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100'},
    {isTotalRow:true, totalCaption: 'Total: All',
        totalCaptionAlignment: 'right',  
        colSpan: 9,
        voucherTxnType:'Voucher Type: All',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100'
    },
]

export const summaryTableStyles = {
    0: {cellWidth: 131.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: { cellWidth: 120.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 142.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 131.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 131.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 131.11, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 100, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 100, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 95, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 100, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
  }
  export const detailedTableStyles = {
    0: {cellWidth: 50, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: { cellWidth: 90,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 140,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 140,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 140,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 117.9,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 117.9,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 117.9,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 100,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 117.9,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    10: { cellWidth: 140,halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    11: { cellWidth: 80,halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    12: { cellWidth: 80,halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    13: { cellWidth: 80,halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    14: { cellWidth: 80,halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    15: { cellWidth: 105,halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
 
}

export const getColoumnOnCreateVoucher = (translations) => {
    const d = rdcn(translations)
    return [
    {
      header: d.lrNo || 'LR No',
      pdfHead: d.lrNoManLrNo || 'LR No.\nMan LR No',
      field: 'LRNO',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 1,
    },
  
    {
      header: d.bookingDateTime || 'Booking Date & Booking Time',
      pdfHead: d.bkgDateTime || ' Bkg. Date\nBkg. Time',
      field: 'BookingDateTime',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 2,
    },
    {
      header: d.sourceCityBranch || 'Source City & Source Branch',
      pdfHead: d.srcCityBr || 'Src. City\nSrc. Br.',
      field: 'BookingCity',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 3,
    },
    {
      header: d.destinationCityBranch || 'Destination City & Destination Branch',
      pdfHead: d.dstCityBr || 'Dst. City\nDst. Br',
      field: 'DestinationCity',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 4,
    },
  
    {
      header: d.senderDetails || 'Sender\nDetails',
      pdfHead: d.senderDetails || 'Sender\nDetails',
      field: 'Sender',
      xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 5,
    },
    {
      header: d.receiverDetails || 'Receiver\nDetails',
      pdfHead: d.receiverDetails || 'Receiver\nDetails',
      field: 'Receiver',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 6,
    },
    {
      header: d.bookedByUser || 'Booked By User',
      pdfHead: d.bkgByUser || 'Bkg. By\nUser',
      field: 'BookedBy',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 7,
    },
    {
      header: d.itemName || 'Item Name',
      pdfHead: d.itemNameNl || 'Item\nName',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      field: 'ItemDetails',
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 8,
    },
    {
      header: d.lrStatus || 'LR Status',
      pdfHead: d.lrStatusNl || 'LR\nStatus',
      field: 'Status',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 9,
    },
    {
      header: d.itemUnits || 'Item Units',
      pdfHead: d.itemUnitsNl || 'Item\nUnits',
      field: 'Items',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 10,
    },
    {
      header: d.freightCharge || 'Freight Charge',
      pdfHead: d.frtChrg || 'Frt.\nChrg',
      field: 'Freight',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 11,
    },
    {
      header: d.documentCharge || 'Document Charge',
      pdfHead: d.docChrg || 'Doc.\nChrg',
      field: 'DocumentCharges',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 12,
    },
    {
      header: d.cartageCharge || 'Cartage Charge',
      pdfHead: d.cartChrg || 'Cart.\nChrg',
      field: 'CartageAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 13,
    },
    {
      header: d.hamaliCharge || 'Hamali Charge',
      pdfHead: d.hamChrg || 'Ham.\nChrg',
      field: 'HamaliCharges',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 14,
    },
    {
      header: d.operatorHamaliCharge || 'Operator Hamali Charge',
      pdfHead: d.opHam || 'op.\nHam.',
      field: 'OperatorHamaliChg',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 15,
    },
  
    {
      header: d.valuationCharge || 'Valuation Charge',
      pdfHead: d.valChrg || 'Val.\nChrg',
      field: 'Valuation',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 16,
    },
    {
      header: d.otherCharge || 'Other Charge',
      pdfHead: d.othChrg || 'oth.\nChrg',
      field: 'OtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 17,
    },
    {
      header: d.bookingGst || 'Booking GST',
      pdfHead: d.bkgGst || 'Bkg.\nGST',
      field: 'BookingGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 18,
    },
    {
      header: d.netAmount || 'Net Amount',
      pdfHead: d.netAmt || 'Net\nAmt',
      field: 'NetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 19,
    },
    {
      header: d.deliveryHamali || 'Delivery Hamali',
      pdfHead: d.delHam || 'Del.\nHam',
      field: 'DelHamali',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 20,
    },
    {
      header: d.delCartageAmount || 'DelCartage Amount',
      pdfHead: d.delCart || 'Del.\nCart',
      field: 'DelCartage',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 21,
    },
    {
      header: d.demurrageCharge || 'Demurrage Charge',
      pdfHead: d.demChrg || 'Dem.\nChrg',
      field: 'DemurrageChg',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 22,
    },
    {
      header: d.deliveryGst || 'Delivery GST',
      pdfHead: d.delGst || 'Del.\nGst',
      field: 'DeliveryGST',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 23,
    },
    {
      header: d.netOutstandingAmount || 'Net OutStanding Amount',
      pdfHead: d.netOsAmt || 'NetO/S\nAmt',
      field: 'Outstanding',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 24,
    },
  ]
}

 export const filterSummary= {
    0: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    1: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    2: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    3: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    4: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
    5: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
  }
 export const filterDetailed= {
    0: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
    1: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
    2: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
    3: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
    4: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
    5: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal',halign: 'left' },
  }
